import ReactGA from 'react-ga4';

export const useGoogleAnalytics = () => {
  // TODO: Typing
  const addToCart = (item: any) => {
    ReactGA.event('add_to_cart', {
      items: [
        {
          item_id: item.itemId,
          item_name: item.name,
          item_category: item.category,
          item_category2: item.subcategory,
          quantity: item.units,
          price: item.price,
        },
      ],
    });
  };

  // TODO: Typing
  const beginCheckout = (items: any) => {
    const itemsData = items.map((item: any) => ({
      item_id: item.id,
      item_name: item.name,
      item_category: item.hotel.id,
      item_category2: item.type,
      item_category3: item.genericServices?.map((service: any) => service.service.name),
      item_category4: item.genericActivities?.map((activity: any) => activity.name),
      item_category5: item.genericGuestRoomRequests?.map((room: any) => room.guestRoom.name),
      item_category6: item.extraServices?.map((service: any) => service.service.name),
      item_units: item.itemsCount,
    }));
    ReactGA.event('begin_checkout', {
      items: itemsData,
    });
  };
  const emptyAllCart = (items: any) => {
    const itemsData = items.map((item: any) => ({
      item_id: item.id,
      item_name: item.name,
      item_category: item.hotel.id,
      item_category2: item.type,
      item_category3: item.genericServices?.map((service: any) => service.service.name),
      item_category4: item.genericActivities?.map((activity: any) => activity.name),
      item_category5: item.genericGuestRoomRequests?.map((room: any) => room.guestRoom.name),
      item_category6: item.extraServices?.map((service: any) => service.service.name),
      item_units: item.itemsCount,
    }));
    ReactGA.event('remove_from_cart', {
      items: itemsData,
    });
  };

  const noop = () => {};

  // TODO: Typing
  const purchaseCart = (items: any) => {
    const itemsData = items.map((item: any) => ({
      item_id: item.id,
      item_name: item.name,
      item_category: item.hotel.id,
      item_category2: item.type,
      item_category3: item.genericServices?.map((service: any) => service.service.name),
      item_category4: item.genericActivities?.map((activity: any) => activity.name),
      item_category5: item.genericGuestRoomRequests?.map((room: any) => room.guestRoom.name),
      item_category6: item.extraServices?.map((service: any) => service.service.name),
      item_units: item.itemsCount,
    }));
    ReactGA.event('purchase', {
      items: itemsData,
    });
  };

  // TODO: Typing
  const removeFromCart = (items: any) => {
    const itemData = items.map((item: any) => ({
      item_id: item.id,
      item_name: item.service
        ? item.service.name
        : item.meetingRoom
        ? item.meetingRoom.name
        : item.guestRoom
        ? item.guestRoom.name
        : item.name,
      item_category: item.type,
      item_category2: item?.subcategory,
    }));

    ReactGA.event('remove_from_cart', {
      items: itemData,
    });
  };

  // TODO: Typing
  const search = ({ term, ...restArgs }) => {
    ReactGA.event('search', {
      search_term: term,
      ...restArgs,
    });
  };

  // TODO: Typing
  const selectContent = (content: any) => {
    ReactGA.event('select_content', {
      content_type: content.contentType,
      content_id: content.contentId,
    });
  };

  // TODO: Typing
  const selectItem = (item: any) => {
    ReactGA.event('select_item', {
      items: [
        {
          item_id: item.id,
          item_category: item.category,
          item_category2: item.subcategory,
          item_name: item.name,
        },
      ],
    });
  };

  // TODO: Typing
  const viewCart = (items: any) => {
    const itemsData = items.map((item: any) => ({
      item_id: item.id,
      item_name: item.name,
      item_category: item.hotel.id,
      item_category2: item.type,
      item_category3: item.genericServices?.map((service: any) => service.service.name),
      item_category4: item.genericActivities?.map((activity: any) => activity.name),
      item_category5: item.genericGuestRoomRequests?.map((room: any) => room.guestRoom.name),
      item_category6: item.extraServices?.map((service: any) => service.service.name),
      item_units: item.itemsCount,
    }));
    ReactGA.event('view_cart', {
      items: itemsData,
    });
  };

  if (ReactGA.isInitialized) {
    return {
      addToCart,
      beginCheckout,
      emptyAllCart,
      purchaseCart,
      removeFromCart,
      search,
      selectContent,
      selectItem,
      viewCart,
    };
  }

  return {
    addToCart: noop,
    beginCheckout: noop,
    emptyAllCart: noop,
    purchaseCart: noop,
    removeFromCart: noop,
    search: noop,
    selectContent: noop,
    selectItem: noop,
    viewCart: noop,
  };
};

export default useGoogleAnalytics;
